import { render } from "./MultiplechoiceElement.vue?vue&type=template&id=b81c8698&scoped=true"
import script from "./MultiplechoiceElement.vue?vue&type=script&lang=js"
export * from "./MultiplechoiceElement.vue?vue&type=script&lang=js"

import "./MultiplechoiceElement.vue?vue&type=style&index=0&id=b81c8698&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81c8698"]])

export default __exports__